import { useParams } from "react-router";
import { ArtefactNotReadyAlert } from "@/shared/service-manager/artefact/artefact-sheet";
import { useErrArtefactNotReady } from "@/shared/service-manager/artefact/err-artefact-not-ready";
import {
  MilestonePage,
  MilestonePageContent,
} from "@/shared/service-manager/default-ui/milestone-page/milestone-page";
import { DifferentiationsTable } from "./differentiations-table";

export function DifferentiationsIndexRoute() {
  const { processId } = useParams();
  const { notReadyError } = useErrArtefactNotReady();

  return (
    <MilestonePage>
      <MilestonePageContent>
        <ArtefactNotReadyAlert
          error={notReadyError}
          artefact="Differentiation"
        />
        <DifferentiationsTable processId={processId!} />
      </MilestonePageContent>
    </MilestonePage>
  );
}
